import { render, staticRenderFns } from "./ShowSocialMediaLinks.vue?vue&type=template&id=563c3e3f"
import script from "./ShowSocialMediaLinks.vue?vue&type=script&lang=js"
export * from "./ShowSocialMediaLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports